import React from "react";
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminLayout from "./components/AdminLayout";
import AdminDashboard from "./pages/admin/Dashboard";
import Members from "./pages/admin/Members";
import MemberSignup from "./pages/admin/MemberSignup";
import Leads from "./pages/admin/Leads";
import Invoices from "./pages/admin/Invoices";
import Inventory from "./pages/admin/Inventory";
import Equipment from "./pages/admin/Equipment";
import HR from "./pages/admin/HR";
import Trainers from "./pages/admin/Trainers";
import Packages from "./pages/admin/Packages";
import Tasks from "./pages/admin/Tasks";
import Attendance from "./pages/admin/Attendance";
import Reports from "./pages/admin/Reports";
import DietWorkout from "./pages/admin/DietWorkout";
import MemberPortal from "./pages/admin/MemberPortal";
import Housekeeping from "./pages/admin/Housekeeping";
import Branches from "./pages/admin/Branches";
import StaffAttendance from "./pages/admin/StaffAttendance";
import Security from "./pages/admin/Security";
import Procurement from "./pages/admin/Procurement";
import StockRegister from "./pages/admin/StockRegister";
import PettyCash from "./pages/admin/PettyCash";
import AdminLogin from "./pages/admin/Login";
import Settings from "./pages/admin/Settings";
import Onboarding from "./pages/public/Onboarding";
import Home from "./pages/website/Home";

// Enable secure cookies globally for Axios
axios.defaults.withCredentials = true;

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<AdminLogin />} />
        <Route path="/member" element={<MemberPortal />} />
        <Route path="/onboard" element={<Onboarding />} />
        
        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="members" element={<Members />} />
          <Route path="members/new" element={<MemberSignup />} />
          <Route path="leads" element={<Leads />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="tasks" element={<Tasks />} />
          <Route path="packages" element={<Packages />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="equipment" element={<Equipment />} />
          <Route path="hr" element={<HR />} />
          <Route path="trainers" element={<Trainers />} />
          <Route path="plans" element={<DietWorkout />} />
          <Route path="reports" element={<Reports />} />
          <Route path="housekeeping" element={<Housekeeping />} />
          <Route path="branches" element={<Branches />} />
          <Route path="staff-attendance" element={<StaffAttendance />} />
          <Route path="security" element={<Security />} />
          <Route path="procurement" element={<Procurement />} />
          <Route path="stock-register" element={<StockRegister />} />
          <Route path="petty-cash" element={<PettyCash />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
